var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneySend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.583 9.167c0 .646.5 1.166 1.114 1.166H8.95c.533 0 .967-.453.967-1.02 0-.606-.267-.826-.66-.966l-2.007-.7c-.393-.14-.66-.354-.66-.967 0-.56.433-1.02.967-1.02H8.81c.613 0 1.113.52 1.113 1.167M8.25 5v6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.917 8a6.67 6.67 0 0 1-6.667 6.667A6.67 6.67 0 0 1 1.583 8 6.67 6.67 0 0 1 8.25 1.333M14.917 4V1.333H12.25m-.667 3.334 3.334-3.334"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySend);
export default __webpack_public_path__ + "static/media/money-send.50c1846cf706f06bc96f245a45f35942.svg";
export { ForwardRef as ReactComponent };